<template>

    <div id="homepage">
        <div class="loading" v-if="loading">Loading...</div>
    homepage.vue
        <h2 class="title is-2">Posts</h2>
        <list-posts v-bind:posts="posts"></list-posts>

    </div>
</template>

<script>
import axios from 'axios'
import ListPosts from '../global/ListPosts.vue'

export default {
  name: 'Homepage',
  data () {
    return {
      title: 'Wp-headless demo',
      posts: []
    }
  },

  created () {
    this.getPosts()
    document.title = this.title
  },

  methods: {
    getPosts () {
      let postsUrl =  this.apiUrl + '/wp-json/wp/v2/posts'
        this.loading = true
      if (this.$route.query.page !== undefined) {
        postsUrl += '?page=' + this.$route.query.page
      }

      axios.get(postsUrl)
      .then(response => {
        this.posts = response.data
      })

      .catch(e => {
        console.log(e)
      })
        this.loading = false
    }
  },

  components: {
    'list-posts': ListPosts
  }
}
</script>
